var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"formater-attribution"},[(_vm.url)?_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.name))]):_c('span',[_vm._v(_vm._s(_vm.name))]),_vm._v(" \n "+_vm._s(_vm.$t('developed_by'))+" "),_c('a',{attrs:{"href":_vm.$t('formater_uri'),"target":"_blank"}},[_vm._v("ForM@Ter")])])
}
var staticRenderFns = []

export { render, staticRenderFns }